import { render, staticRenderFns } from "./companyverifycheck.vue?vue&type=template&id=892bc5e4&scoped=true"
import script from "./companyverifycheck.vue?vue&type=script&lang=js"
export * from "./companyverifycheck.vue?vue&type=script&lang=js"
import style0 from "./companyverifycheck.vue?vue&type=style&index=0&id=892bc5e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892bc5e4",
  null
  
)

export default component.exports